import React from "react";
import "./Transformations.css";

export default function Transformations() {
  return (
    <div className="Transformations">
      <div className="trans-slide">
        <img src="/images/transformations/0.png" alt="transformation1" />
        <img src="/images/transformations/1.png" alt="transformation2" />
        <img src="/images/transformations/2.png" alt="transformation3" />
        <img src="/images/transformations/3.png" alt="transformation4" />
        <img src="/images/transformations/4.png" alt="transformation5" />
        <img src="/images/transformations/5.png" alt="transformation6" />
        <img src="/images/transformations/6.png" alt="transformation7" />
        <img src="/images/transformations/7.png" alt="transformation8" />
        <img src="/images/transformations/8.png" alt="transformation9" />
        <img src="/images/transformations/9.png" alt="transformation10" />
        <img src="/images/transformations/10.png" alt="transformation11" />
        <img src="/images/transformations/11.png" alt="transformation12" />
        <img src="/images/transformations/12.png" alt="transformation13" />
        <img src="/images/transformations/13.png" alt="transformation14" />

        <img src="/images/transformations/0.png" alt="transformation1" />
        <img src="/images/transformations/1.png" alt="transformation2" />
        <img src="/images/transformations/2.png" alt="transformation3" />
        <img src="/images/transformations/3.png" alt="transformation4" />
        <img src="/images/transformations/4.png" alt="transformation5" />
        <img src="/images/transformations/5.png" alt="transformation6" />
        <img src="/images/transformations/6.png" alt="transformation7" />
        <img src="/images/transformations/7.png" alt="transformation8" />
        <img src="/images/transformations/8.png" alt="transformation9" />
        <img src="/images/transformations/9.png" alt="transformation10" />
        <img src="/images/transformations/10.png" alt="transformation11" />
        <img src="/images/transformations/11.png" alt="transformation12" />
        <img src="/images/transformations/12.png" alt="transformation13" />
        <img src="/images/transformations/13.png" alt="transformation14" />
      </div>

      {/* <div className="test-slide">
        <div>
          "AS Coaching transformed my whole mindset on training & nutrition. I
          feel stronger, fitter & healthier than ever."
        </div>
        <div></div>
        <div>
          "I got in phenominal shape just after 12 weeks following the training
          & diet plan with AS Coaching. Can't wait to see the progress after 1
          year."
        </div>
        <div>
          "AS Coaching helped me lost over 8KG of bodyfat in just 9 weeks."
        </div>
        <div>
          "AS Coaching helped me lose over 7kg of bodyfat and put on 6kg of
          muscle in the space of 12 weeks. I wouldn't of been able to do it
          without the AS Coaching."
        </div>
        <div></div>
        <div></div>
        <div>
          "AS Coaching got me in the best shape I've been in years, in just 6
          weeks"
        </div>
        <div></div>
      </div> */}
    </div>
  );
}
